<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-button type="primary" plain icon="el-icon-plus" @click="addRestaurant">新增</el-button>
    </div>
    <div style="max-height: calc(100% - 120px);margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="餐厅名"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="createdat"
          label="创建时间"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="updatedat"
          label="更新时间"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column align="center" label="操作" width="160">
          <template slot-scope="scope">
            <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="openEdit(scope.row)"></i>
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delRestaurant(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="500px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{addEditTitle}}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-restaurant :restaurantObj="restaurantObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-restaurant>
    </el-dialog>
  </div>
</template>

<script>
import {queryrestaurant, deleterestaurant} from '../../api/yanglaoyuan'
import addEditRestaurant from './components/addEditRestaurant'
export default {
  name: 'restaurantManagement',
  components: {addEditRestaurant},
  data () {
    return {
      entityId: 0,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      addEditTitle: '',
      addEditShow: false,
      restaurantObj: {
        isAdd: true,
        row: ''
      }
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getTableData()
  },
  methods: {
    getTableData () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        eid: this.entityId
      }
      queryrestaurant(params, data).then(res => {
        this.tableData = res.data.restaurants
        this.totalCells = res.data.cnt
      })
    },
    addRestaurant () {
      this.addEditTitle = '新增餐厅'
      this.restaurantObj.isAdd = true
      this.restaurantObj.row = ''
      this.addEditShow = true
    },
    openEdit (row) {
      this.addEditTitle = '编辑餐厅'
      this.restaurantObj.isAdd = false
      this.restaurantObj.row = row
      this.addEditShow = true
    },
    delRestaurant (row) {
      this.$confirm('此操作将永久删除该餐厅【' + row.name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deleterestaurant(data).then(res => {
          this.$notify({title: '成功', message: '成功删除餐厅', type: 'success', duration: 2000})
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.getTableData()
        })
      })
    },
    updateTable () {
      this.getTableData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTableData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/restaurantManagement.vue